import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LocalSeeOutlinedIcon from "@mui/icons-material/LocalSeeOutlined";

interface ChangePhotoProps {
  onChangePhoto?: () => void;
  expandPhoto?: boolean;
}

export default function ChangePhoto({
  onChangePhoto,
  expandPhoto,
}: ChangePhotoProps) {
  return (
    <Box
      sx={{
        position: "absolute",
        top: expandPhoto ? "20px" : "50%",
        left: "50%",
        width: "100%",
        textAlign: "center",
        transform: "translate(-50%, -50%)",
        paddingTop: !expandPhoto ? null : "5px",
        borderTop: expandPhoto ? "1px solid #fff" : null,
        cursor: "pointer",
      }}
      onClick={onChangePhoto}
    >
      <LocalSeeOutlinedIcon style={{ color: "white" }} />
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          top: "36px",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="white"
          fontWeight={600}
        >
          Change Photo
        </Typography>
      </Box>
    </Box>
  );
}
